import { render } from "./VendorPriceValidatorShow.vue?vue&type=template&id=3081dcc9"
import script from "./VendorPriceValidatorShow.vue?vue&type=script&lang=js"
export * from "./VendorPriceValidatorShow.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__